const RECOVER_HASH = '#recover'

export default {
    name: 'customer_login',
    component() {
        return {
            showPasswordReset: false,
            showCustomerAccountFormPopup: false,
            init() {
                if (window.location.hash === RECOVER_HASH) {
                    this.showPasswordReset = true
                }

                window.addEventListener("toggle-display-open", (e) => {
                    if (e.detail.message === "header-signin") {
                        this.showCustomerAccountFormPopup = !this.showCustomerAccountFormPopup;
                    } else if (e.detail.message?.type === "reset-password") {
                        this.showCustomerAccountFormPopup = true;
                    }
                });
            },
            toggleShowPasswordReset() {
                this.showPasswordReset = !this.showPasswordReset;

                if (this.showPasswordReset) {
                    history.replaceState(null, null, RECOVER_HASH);
                } else {
                    history.replaceState(null, null, ' ');
                }
            },
            scrollToTop () {
                window.scrollTo({ top: 0, left: 0 });
            }
        }
    }
}